import React         from 'react';
import classNames    from 'classnames';
import { Observe }        from 'rewire-core';
import Avatar             from '@material-ui/core/Avatar';
import Card               from '@material-ui/core/Card';
import CardActions        from '@material-ui/core/CardActions';
import CardContent        from '@material-ui/core/CardContent';
import Divider            from '@material-ui/core/Divider';
import IconButton         from '@material-ui/core/IconButton';
import Typography         from '@material-ui/core/Typography';
import TagIcon            from '@material-ui/icons/BookmarksRounded';
import EditIcon           from '@material-ui/icons/Edit';
import VisibilityIcon     from '@material-ui/icons/Visibility';
import OtherFieldsCardView, {
  useOtherFieldCardStyle,
}                         from './OtherFieldsCardView';
import SettingsModel      from './SettingsModel';
import Udfs               from './Udfs';

const Tags = ({ item }: any) => {
  const classes = useOtherFieldCardStyle();
  return (
    <Observe>{() => {
      if (!item.tags) return null;
      return (
        <div className={classNames(classes.row, classes.box)}>
          <TagIcon className={classes.icon} />
          <Typography variant='subtitle1' className={classes.iconSubTitle}>{item.tags.join(', ')}</Typography>
        </div>
      );
     }}</Observe>
  );
};

export default ({classes, settings}: {classes: any, settings: SettingsModel}) => {
  const otherClasses = useOtherFieldCardStyle();
  return (
    <div className={classes.gridWrapper}>
      <div className={classes.grid}>
        <Observe>{
          () => (settings.items.map((i: any) =>
            <Observe key={i.id}>{() => {
              const ref = React.useRef<HTMLElement>(null);
              if (i.selected && ref?.current) {
                ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }

              return (
                <Card ref={ref} elevation={i.selected ? 8 : 2} className={classNames(classes.card, {selected: i.selected, archived: i.archived})}>
                  <CardContent className={classes.cardContent}>
                    <div style={{display: 'flex'}}>
                      <Typography className={classes.title} color='textSecondary' gutterBottom>
                        {i.code}
                      </Typography>
                      {i.url && <Avatar alt='Avatar' src={i.url} className={classes.avatar} />}
                    </div>
                    <Typography variant='h5' component='h2'>
                      {i.name}
                    </Typography>
                    <div className={otherClasses.root}>
                      {settings.otherFields && <OtherFieldsCardView item={i} fields={settings.otherFields} />}
                      <Tags item={i} />
                    </div>
                    <Udfs udfs={settings.udfs} item={i} />
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <IconButton className={classes.cardIcon} aria-label='Edit' onClick={() => settings.selectItem(i)}>
                      {settings._canEditItem ? <EditIcon /> : <VisibilityIcon/>}
                    </IconButton>
                    {/* <IconButton className={classNames(classes.cardIcon, classes.delete)} onClick={settings.removeItem} aria-label='Delete'>
                      <DeleteIcon />
                    </IconButton> */}
                  </CardActions>
                </Card>
              );
            }}</Observe>
          ))}
        </Observe>
      </div>
    </div>
  );
};
